import React, { useEffect, useState } from "react";

import { Grid, Container, Paper, Typography } from "@material-ui/core";
import Header from "./Components/Header";
import CircularProgress from "@material-ui/core/CircularProgress";
import Sections from "./Sections";
import uuid from "react-uuid";
import { withStyles } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Colors from "./../../Global/colors";
import DarkButton from "./../../Global/DarkButton";
import LightButton from "./../../Global/LightButton";
import GlobalApi from "./../../Global";
import Spinner from "./../../Global/Spinner";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import useDimensions from "./../../Global/useDimensions";
import swal from "@sweetalert/with-react";
import refresh_token from "./../../Global/refresh_token";
import Preview from "./Preview";
import "./template.css";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import AddIcon from "@material-ui/icons/Add";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Template(props) {
  const { t } = useTranslation();
  // let TEMPLATE_ID = "1dee5d30-4326-417b-baaa-2947662faa24";
  let TEMPLATE_ID = props?.history?.location?.state.templateId;
  const [template, setTemplate] = useState(null);
  const [templateDetails, setTemplateDetails] = useState(null);
  const [responseLibrary, setResponseLibrary] = useState(null);
  const [currentCompany, setCurrentCompany] = useState("");
  const [btnLoader, setBtnLoader] = useState(false);
  const [dataType, setDataType] = useState("Text Field");
  const [activeSection, setActiveSection] = useState(0);
  const [open, setOpen] = useState(false);
  const [deleteChecklistArr, setDeleteChecklistArr] = useState([]);
  const history = useHistory();

  let company = useSelector((state) => state.companyReducer.company);

  useEffect(
    () => {
      setCurrentCompany(company);
      getTemplate(TEMPLATE_ID, false);
      getResponseLibrary(TEMPLATE_ID, company);
      // window.innerWidth >= 960 &&
      //   console.log((document.querySelector("#main").style.overflow = "hidden"));
      // // p
      // return () => {
      //   document.querySelector("#main").style.overflow = "auto";
      // };
    },
    [company?.id]
  );

  function removeDuplicates(arr) {
 

    let jsonObject = arr.map(JSON.stringify);
    let uniqueSet = new Set(jsonObject);
    let uniqueArray = Array.from(uniqueSet).map(JSON.parse);
  
    return uniqueArray;
  }
  async function getTemplate(template_id, isSave) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      template_id,
    };
    console.log("WRYYYYYYYYYY");
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    let req = await fetch(
      GlobalApi + "/Template/get_template_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let res = await req.json();
    console.log("response from get template details ", res);
    if (res.status === "Success") {
      var data = res.data;

      console.log(res.data);
      var sections = [];
      var title = data.title;
      var template_Id = data.id;
      var des = data.description;
      await data.Sections.map((sec) => {
        var checklist = [];
        var checklistTest = [];
        sec.CheckLists.map((item) => {
          var responseList = [];
          var conditionalList = [];
          var subQuestionList = [];

          if (item.data_type == "Custom" || item.data_type == "Global") {
            item.ResponseSets.map((r) => {
              var item = {
                id: r.response_id,
                title: r.title,
                position: r.position,
                weight: r.weight,
              };
              responseList.push(item);
              console.log(r);
            });
            var responseLibrary = {
              id: item.id,
              responses:removeDuplicates(responseList.sort((a, b) => a.position - b.position)),
            };
          }

          if (item.is_conditional == "yes" ) {
            var list = sec.CheckLists.filter((x) => x.parent_id == item.id && x?.type !== "subquestion" );
            var responseListCQ = [];

            list.map((item) => {
              //alert(JSON.stringify(item.ResponseSets))
              if (item.data_type == "Custom" || item.data_type == "Global") {
                item.ResponseSets.map((r) => {
                  var responseItem = {
                    id: r.response_id,
                    title: r.title,
                    position: r.position,
                    weight: r.weight,
                  };
                  responseListCQ.push(responseItem);
                });
                var responseLibraryCQ = {
                  id: item.id,
                  responses:removeDuplicates(responseListCQ.sort(
                    (a, b) => a.position - b.position
                  )),
                };
              }
              var conditionalItem = {
                id: item.id,
                title: item.title,
                dataType: item.data_type,
                position: item.position,
                status: "added",
                mandatory: item.is_mandatory,
                multiselection: item.is_multiple_allowed,
                condition: item.condition,
                conditionValue: item.condition_value,
                conditional: item.is_conditional,
                is_subquestion: item.is_subquestion,
                type: item.type,
                parent: item.parent_id,
                isopen: "no",
                // conditionalList: [],
                // subQuestionList: [],
                responseLibrary:
                  item.data_type == "Custom" || item.data_type == "Global"
                    ? responseLibraryCQ
                    : [],
              };
              conditionalList.push(conditionalItem);
            });
          
          }

          if (item.is_subquestion == "yes") {
            var list = sec.CheckLists.filter((x) => x.parent_id == item.id && x.type && x.type == "subquestion");
            var responseListSQ = [];

            list.map((item) => {
              //alert(JSON.stringify(item.ResponseSets))
              if (item.data_type == "Custom" || item.data_type == "Global") {
                item.ResponseSets.map((r) => {
                  var responseItem = {
                    id: r.response_id,
                    title: r.title,
                    position: r.position,
                    weight: r.weight,
                  };
                  responseListSQ.push(responseItem);
                });
                //alert(JSON.stringify(item.ResponseSets))
                var responseLibrarySQ = {
                  id: item.id,
                  responses: removeDuplicates(responseListSQ.sort(
                    (a, b) => a.position - b.position
                  )),
                };
              }
              var subQuestionItem = {
                id: item.id,
                title: item.title,
                dataType: item.data_type,
                position: item.position,
                status: "added",
                mandatory: item.is_mandatory,
                multiselection: item.is_multiple_allowed,
                condition: item.condition,
                conditionValue: item.condition_value,
                conditional: item.is_conditional,
                is_subquestion: item.is_subquestion,
                type: item.type,
                parent: item.parent_id,
                isopen: "no",
                // conditionalList: [],
                // subQuestionList: [],
                responseLibrary:
                  item.data_type == "Custom" || item.data_type == "Global"
                    ? responseLibrarySQ
                    : [],
              };
              subQuestionList.push(subQuestionItem);
            });
          
          }
       
          var newChecklist = {
            id: item.id,
            title: item.title,
            dataType: item.data_type,
            position: item.position,
            status: "added",
            mandatory: item.is_mandatory,
            multiselection: item.is_multiple_allowed,
            condition: item.condition,
            conditionValue: item.condition_value,
            conditional: item.is_conditional,
            is_subquestion: item.is_subquestion,
            type: item.type,
            parent: item.parent_id,
            isopen: "no",
            isopenSub: "no",
            conditionalList: conditionalList.sort(function(a, b) {
              return a.position - b.position;
            }),
            subQuestionList: subQuestionList.sort(function(a, b) {
              return a.position - b.position;
            }),
            responseLibrary:
              item.data_type == "Custom" || item.data_type == "Global"
                ? responseLibrary
                : [],
          };
          if (item.parent_id == null) checklist.push(newChecklist);
        });
        
        var sectionList = {
          template: { id: sec.id },
          list: checklist.sort(function(a, b) {
            return a.position - b.position;
          }),
        };

        var section = {
          id: sec.id,
          title: sec.title,
          type: sec.type,
          status: "added",
          position: sec.position,
          checklist: sectionList,
        };
        sections.push(section);
      });
      var blank_template = {
        sections,
      };
      await setTemplate(
        blank_template.sections
          .sort(function(a, b) {
            return a.position - b.position;
          })
          .filter((v) => v.status !== "frozen")
      );
      setTemplateDetails(res.data);

      if (isSave) {
        setBtnLoader(false);
        swal(t("Success"), t("Section Saved Successfully"), "success");
      }
    } else if (
      res.error === "jwt expired" ||
      res.error === "invalid token" ||
      res.error === "invalid signature" ||
      res.error === "Unexpected token"
    ) {
      let status = await refresh_token();
      if (status) {
        getTemplate();
      }
    }
  }


  console.log("tempalteXXXXXXX", template);

  const getResponseLibrary = async (template_id, company_id) => {
    console.log("RESPONSE LIBRARY CALLED");
    var retrievedData = localStorage.getItem("UserData");
    var data = JSON.parse(retrievedData);
    if (data.token == null) {
      return false;
    }
    var params = {
      template_id: template_id ? template_id : templateDetails.id,
      company_id: company.id,
    };
    console.log("params ()()()()()()()()()()()()()()()", params);
    console.log(params, "response paper");
    var token = data.token;
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    setTimeout(() => {
      fetch(GlobalApi + "/Response/get_all_responses_template?" + query, {
        method: "GET",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
      })
        .then((response) => response.json())
        .then(async (res) => {
          console.log("response from get all response template ", res);
          if (res.status === "Success") {
            var list = [];
            if (res.data.length === 0) {
              setResponseLibrary(list);
              return;
            }
            await res.data.map(async (response) => {
              var id = response.id;
              var title = response.title;
              var identifier = response.identifier;
              var responseList = [];
              await response.ResponseDetails.map((item) => {
                // if(item.weight !=null)
                // alert("Title: "+item.title + " Weight:"+item.weight)
                var item = {
                  id: item.id,
                  title: item.title,
                  position: parseInt(item.position),
                  weight: item.weight,
                };
                // console.log(item, "heheheh")
                responseList.push(item);
              });
              var newItem = {
                id: id,
                title: title,
                identifier: identifier,
                responses: responseList.sort((a, b) => a.position - b.position),
              };
              list.push(newItem);
            });

            await setResponseLibrary(list);
          } else if (
            res.error === "jwt expired" ||
            res.error === "invalid token" ||
            res.error === "invalid signature" ||
            res.error == "Unexpected token"
          ) {
            let status = await refresh_token();
            console.log(status);
            if (status) {
              getResponseLibrary(template_id, currentCompany.id);
            }
          }
        })
        .catch((err) => {
          // alert(err);
          console.log(err, "error");
        });
    }, 1000);
  };

  const onUpdateChecklist = (
    checklist,
    template_1,
    source,
    destinationIndex,
    action
  ) => {
    console.log(checklist, "HANDS UPPP", action);
    if (template_1 == "main") {
      if (action == "Change Section Position") {
        checklist.map((item, index) => {
          if (item.status != "deleted" && item.status != "New") {
            item.status = "changed";
          }

          item.position = index + 1;
        });
      }
      setTemplate([...checklist]);
      return;
    }
    var indx = -1;
    // console.log(template)
    var temp = [...template];
    // indx = temp.findIndex((x) => x.id.toString() == template_1.id.toString());
    indx = activeSection;
    if (indx != -1) {
      if (action == "Change List Option") {
        temp[indx].checklist.list = checklist;
        if (
          temp[indx].status != "New" &&
          temp[indx].checklist.list[destinationIndex].status != "New"
        ) {
          temp[indx].checklist.list[destinationIndex].status = "changed";
          temp[indx].status = "changed";
        }
        setTemplate([...temp]);
        return;
      }

      if (action == "Delete") {
        console.log("OP", destinationIndex, indx);
        console.log();
        temp[indx].checklist.list[destinationIndex].status = "deleted";
        if (temp[indx].status != "New") {
          temp[indx].status = "changed";
        }
        setTemplate(temp);
        console.log(temp);
        return;
      }

      if (action == "Change List Position") {
        indx = activeSection;
        console.log(checklist, "INDEX");
        temp[indx].checklist.list = checklist;
        temp[indx].checklist.list.map((item, index) => {
          if (temp[indx].status != "New" && item.status != "New") {
            item.status = "changed";
            temp[indx].status = "changed";
          }
          item.position = index + 1;
        });
        console.log(temp[indx], indx, "TE<PLA");
        setTemplate([...temp]);
        return;
      }
      if (action == "Change Field Name") {
        console.log(checklist, template_1, source, destinationIndex, action);
        temp[indx].checklist.list = checklist;
        if (
          temp[indx].status != "New" &&
          temp[indx].checklist.list[destinationIndex].status != "New"
        ) {
          temp[indx].checklist.list[destinationIndex].status = "changed";
          temp[indx].status = "changed";
          console.log("HEHEHEH", temp[indx].status);
        }
        setTemplate([...temp]);
        return;
      }
    }
  };


  const addNewQuestion = (itemId, templateId, actionType) => {
    console.log(itemId, templateId, actionType);
    
    let temp = JSON.parse(JSON.stringify(template));
    // const temp = [...template];
    var indx = temp.findIndex((x) => x.id == templateId);

    if (indx != -1) {
      if (actionType == "new") {
        var index =
          itemId == "hard-new"
            ? 0
            : temp[indx].checklist.list.findIndex((x) => x.id == itemId);
        console.log(index);
        var list = temp[indx].checklist.list;
        var addingId = 0;
        var addingIndex = 0;
        if (index < temp[indx].checklist.list.length) {
          addingId = "New-" + uuid();
          addingIndex = index + 1;
        }
        if (index == temp[indx].checklist.list.length) {
          addingId = "New-" + index;
          addingIndex = index;
        }
        var newItem = {
          id: addingId,
          title: "",
          dataType: "Text field",
          position: temp[indx].checklist.list.length + 1,
          status: "New",
          responseLibrary: [],
          mandatory: true,
          multiselection: false,
          condition: "",
          conditionValue: "",
          conditional: "no",
          parent: null,
          isopen: "no",
          conditionalList: [],
          is_subquestion: "no",
          subQuestion:"no",
          isopenSub:"no",
          subQuestionList:[],
        };
        list.splice(addingIndex, 0, newItem);
        if (temp[indx].status != "New") {
          temp[indx].status = "changed";
        }
        temp[indx].checklist.list = list;
        console.log(temp[indx].checklist);
        setTemplate(temp);
      }
      
      if (actionType == "logical") {
        var index = temp[indx].checklist.list.findIndex((x) => x.id == itemId);
        var list = temp[indx].checklist.list[index];
        var conditionalList = [];

      
      
        if (list.conditionalList.length > 0)
          conditionalList = list.conditionalList;

        var addingId = "New-" + uuid();
        var newItem = {
          id: addingId,
          title: "Condition field",
          dataType: "Text field",
          position: 1,
          status: "New",
          responseLibrary: [],
          mandatory: true,
          multiselection: false,
          condition: "",
          conditionValue: "",
          conditional: "no",
          type:"conditional", 
          is_subquestion: "no",
          parent: list.id,
        };
        conditionalList.push(newItem);
        // list.splice(addingIndex,0,newItem)
        
        // temp[indx].checklist.list=list
        var newList = {
          ...list,
          id: list.id,
          title: list.title,
          dataType: list.dataType,
          position: list.position,
          status: list.status,  
          responseLibrary: list.responseLibrary,
          mandatory: list.mandatory,
          multiselection: list.multiselection,
          condition: list.condition,
          conditionValue: list.conditionValue,
          conditional: "yes",//here
          parent: list.parent,
          isopen: "yes",
          type:'parent',
          is_subquestion: list.is_subquestion ? list.is_subquestion : "no",
          conditionalList: conditionalList,
          subQuestion:list.subQuestion ? list.subQuestion : "no",
          isopenSub:list.isopenSub ? list.isopenSub : "no",
          subQuestionList: list.subQuestionList ? list.subQuestionList : [],
        };

       

      

        console.log("temp",temp[indx].checklist.list[index])
        console.log("temp",newList)
        console.log("temp",indx)
        console.log("temp",index)
        // return;
      

      
        temp[indx].checklist.list[index] = newList;

        
        if (temp[indx].status != "New") {
          temp[indx].status = "changed";

          if (temp[indx].checklist.list[index].status != "New") {
            temp[indx].checklist.list[index].status = "changed";
          }
        }
        
        //alert(JSON.stringify(newList))
        setTemplate(temp);
        
      }
      else if(actionType == "sub") {
        var index = temp[indx].checklist.list.findIndex((x) => x.id == itemId);
        var list = temp[indx].checklist.list[index];

        var subQuestionList = [];
        if (list.subQuestionList && list.subQuestionList?.length > 0){
          subQuestionList = list.subQuestionList;
        }

          var addingId = "New-" + uuid();
          var newItem = {
            id: addingId,
            title: "Sub Question",
            dataType: "Text field",
            position: 1,
            status: "New",
            responseLibrary: [],
            mandatory: true,
            multiselection: false,
            condition: "",
            conditionValue: "",
            conditional: "no",
            parent: list.id,
            isQuestionSub:'yes',
            type:'subquestion',
            is_subquestion: "no",
            };
        subQuestionList.push(newItem);
        // list.splice(addingIndex,0,newItem)

        // temp[indx].checklist.list=list
        var newList = {
          id: list.id,
          title: list.title,
          dataType: list.dataType,
          position: list.position,
          status: list.status,
          responseLibrary: list.responseLibrary,
          mandatory: list.mandatory,
          multiselection: list.multiselection,
          condition: list.condition,
          conditionValue: list.conditionValue,
          conditional: list.conditional,
          subQuestion:"yes",
          type:'parent',
          is_subquestion: "yes",
          parent: list.parent,
          isopen: "no",
          isopenSub:"yes",
          subQuestionList: subQuestionList,
          conditionalList: list.conditionalList,
        };

        temp[indx].checklist.list[index] = newList;

        if (temp[indx].status != "New") {
          temp[indx].status = "changed";

          if (temp[indx].checklist.list[index].status != "New") {
            temp[indx].checklist.list[index].status = "changed";
          }
        }

        setTemplate(temp);
        console.log(template);
      }
    }
  };

  const addNewCondition = (templateId, checklistIndex, section) => {
    var temp = [...template];
    let indx = activeSection;
    return;

    if (indx != -1) {
      var list = temp[indx].checklist.list;
      var addingId = 0;
      var addingIndex = 0;
      if (
        checklistIndex <
        temp[indx].checklist.list[checklistIndex].conditionalList.length
      ) {
        addingId = "New-" + uuid();
        addingIndex = checklistIndex + 1;
      }
      if (
        checklistIndex ==
        temp[indx].checklist.list[checklistIndex].conditionalList.length
      ) {
        addingId = "New-" + checklistIndex;
        addingIndex = checklistIndex;
      }
      var newItem = {
        id: addingId,
        title:
          "Condition field " +
          (temp[indx].checklist.list[checklistIndex].conditionalList.length +
          1),
        dataType: "Text field",
        position:
          temp[indx].checklist.list[checklistIndex].conditionalList.length + 1,
        status: "New",
        responseLibrary: [],
        mandatory: true,
        multiselection: false,
        condition: "",
        conditionValue: "",
        conditional: "no",
        type:"conditional",
        is_subquestion: "no",
        parent: temp[indx].checklist.list[checklistIndex].id,
      };

      list[checklistIndex].conditionalList.push(newItem);

      console.log("list[checklistIndex].conditionalList", list);

      if (temp[indx].status != "New") {
        temp[indx].status = "changed";
      }
      if (temp[indx].checklist.list[checklistIndex].status != "New") {
        temp[indx].checklist.list[checklistIndex].status = "changed";
      }
      temp[indx].checklist.list = list;
      setTemplate(temp);
    }
  };

    const addNewSubQuestion = (templateId, checklistIndex, section) => {
    var temp = [...template];
    let indx = activeSection;

    if (indx != -1) {
      var list = temp[indx].checklist.list;
      var addingId = 0;
      var addingIndex = 0;
      if (
        checklistIndex <
        temp[indx].checklist.list[checklistIndex].subQuestionList.length
      ) {
        addingId = "New-" + uuid();
        addingIndex = checklistIndex + 1;
      }
      if (
        checklistIndex ==
        temp[indx].checklist.list[checklistIndex].subQuestionList.length
      ) {
        addingId = "New-" + checklistIndex;
        addingIndex = checklistIndex;
      }
      var newItem = {
        id: addingId,
        title:
          "Sub Question " +
         (Number(temp[indx].checklist.list[checklistIndex].subQuestionList.length) +
          1),
        dataType: "Text field",
        position:
          temp[indx].checklist.list[checklistIndex].subQuestionList.length + 1,
        status: "New",
        responseLibrary: [],
        mandatory: true,
        multiselection: false,
        condition: "",
        conditionValue: "",
        conditional: "no",
        subQuestion:'no',
        isQuestionSub:'yes',
        type:'subquestion',
        is_subquestion: "no",
        parent: temp[indx].checklist.list[checklistIndex].id,
      };

      list[checklistIndex].subQuestionList.push(newItem);

      console.log("list[checklistIndex].conditionalList", list);

      if (temp[indx].status != "New") {
        temp[indx].status = "changed";
      }
      if (temp[indx].checklist.list[checklistIndex].status != "New") {
        temp[indx].checklist.list[checklistIndex].status = "changed";
      }
      temp[indx].checklist.list = list;
      setTemplate(temp);
    }
  };

  const deleteCondition = (item, checklistIndex, conditionalSectionID) => {

    let _deleteChecklistArr = [...deleteChecklistArr];

    var temp = [...template];
    let indx = activeSection;
    console.log("temp*****", temp[indx].checklist.list[checklistIndex]);
   
    if (indx != -1) {
      var list = temp[indx].checklist.list[checklistIndex];

      var deleteIndex = list.conditionalList.findIndex(
        (x) => x.id == conditionalSectionID
      );

      var conditionalList = [];
      conditionalList = list.conditionalList;
      conditionalList.splice(deleteIndex, 1);

    
      
      if (conditionalList.length > 0) {
        

      
        var newList = {
          id: list.id,
          title: list.title,
          dataType: list.dataType,
          position: list.position,
          status: list.status,
          responseLibrary: list.responseLibrary,
          mandatory: list.mandatory,
          multiselection: list.multiselection,
          condition: list.condition,
          conditionValue: list.conditionValue,
          isopenSub: list.isopenSub,
          subQuestionList: list.subQuestionList,
          subQuestion: list.subQuestion,
          is_subquestion: list.is_subquestion,
          type: list.type,
          conditional: conditionalList.length > 0 ? "yes" : "no",
          parent: list.parent,
          isopen: conditionalList.length > 0 ? "yes" : "no",
          conditionalList: conditionalList,
        };

        temp[indx].checklist.list[checklistIndex] = newList;
      }else  {
     
        var newList = {
          id: list.id,
          title: list.title,
          dataType: list.dataType,
          position: list.position,
          status: list.status,
          responseLibrary: list.responseLibrary,
          mandatory: list.mandatory,
          multiselection: list.multiselection,
          condition: "",
          conditionValue: "",
          isopenSub: "no",
          subQuestionList: list.subQuestionList,
          subQuestion: list.subQuestion,
          is_subquestion: list.is_subquestion,
          type: list.type,
          conditional: "no",
          parent: list.parent,
          isopen: "no",
          conditionalList: conditionalList,
        };

        temp[indx].checklist.list[checklistIndex] = newList;
      }

      if (temp[indx].status != "New") {
        temp[indx].status = "changed";

        if (temp[indx].checklist.list[checklistIndex].status != "New") {
          temp[indx].checklist.list[checklistIndex].status =
            "conditionalDeleted";
        }
      }
      console.log("COMMMMM", temp);
      setTemplate(temp);

      _deleteChecklistArr.push(conditionalSectionID);
      setDeleteChecklistArr(_deleteChecklistArr);
    }
  };

  const deleteSubQuestion = (item, checklistIndex, subSectionID) => {
    let _deleteChecklistArr = [...deleteChecklistArr];

    var temp = [...template];
    let indx = activeSection;
    console.log("temp", temp[indx].checklist.list[checklistIndex]);
    if (indx != -1) {
      var list = temp[indx].checklist.list[checklistIndex];

      var deleteIndex = list.subQuestionList.findIndex(
        (x) => x.id == subSectionID
      );

      var subQuestionList = [];
      subQuestionList = list.subQuestionList;
        subQuestionList.splice(deleteIndex, 1);


      if (subQuestionList.length > 0) {
        var newList = {
          id: list.id,
          title: list.title,
          dataType: list.dataType,
          position: list.position,
          status: list.status,
          responseLibrary: list.responseLibrary,
          mandatory: list.mandatory,
          multiselection: list.multiselection,
          condition: list.condition,
          conditionValue: list.conditionValue,
          conditional: list.conditional,
          parent: list.parent,
          isopen: list.isopen,
          type: list.type,
          conditionalList: list.conditionalList,
          isopenSub: subQuestionList.length > 0 ? "yes" : "no",
          subQuestionList: subQuestionList,
          subQuestion: subQuestionList.length > 0 ? "yes" : "no",
          is_subquestion: subQuestionList.length > 0 ? "yes" : "no",
        };

        temp[indx].checklist.list[checklistIndex] = newList;
      }else{
        var newList = {
          id: list.id,
          title: list.title,
          dataType: list.dataType,
          position: list.position,
          status: list.status,
          responseLibrary: list.responseLibrary,
          mandatory: list.mandatory,
          multiselection: list.multiselection,
          condition: list.condition,
          conditionValue: list.conditionValue,
          conditional: list.conditional,
          parent: list.parent,
          isopen: list.isopen,
          type: list.type,
          conditionalList: list.conditionalList,
          isopenSub:"no",
          subQuestionList: subQuestionList,
          subQuestion: "no",
          is_subquestion: "no",
        };

        temp[indx].checklist.list[checklistIndex] = newList;
      }
      if (temp[indx].status != "New") {
        temp[indx].status = "changed";

        if (temp[indx].checklist.list[checklistIndex].status != "New") {
          temp[indx].checklist.list[checklistIndex].status =
            "subDeleted";
        }
      }
      //alert(JSON.stringify(newList))
      setTemplate(temp);

      _deleteChecklistArr.push(subSectionID);
      setDeleteChecklistArr(_deleteChecklistArr);
    }
  };

  const copyNewSection = () => {
    var indx = activeSection;
    var temp = [...template];

    var newID = uuid();
    // var newSection=temp[indx]
    // newSection.id='New-'+newID
    // newSection.title=newSection.title + '- Copy'
    // newSection.status="New"
    var currentSection = temp[indx];
    var addingIndex = 0;
    if (indx < temp.length) {
      addingIndex = indx + 1;
    }
    if (indx == temp.length) {
      addingIndex = indx;
    }
    var newID = uuid();
    var newList = [];
    currentSection.checklist.list.map((item) => {
      var new_conditionalList = [];

      var new_con_Item = {};
      var newItem = {
        id: "New-" + uuid(),
        title: item.title,
        dataType: item.dataType,
        position: item.position,
        status: "New",
        responseLibrary: item.responseLibrary,
        mandatory: item.mandatory,
        multiselection: item.multiselection,
        condition: item.condition,
        conditionValue: item.conditionValue,
        conditional: item.conditional,
        parent: item.parent,
        isopen: item.isopen,
        type: item.type,
        is_subquestion: item.is_subquestion,
        conditionalList: item.conditionalList.map((con_item) => {
          return {
            id: "New-" + uuid(),
            title: con_item.title,
            dataType: con_item.dataType,
            position: con_item.position,
            status: "New",
            responseLibrary: con_item.responseLibrary,
            mandatory: con_item.mandatory,
            multiselection: con_item.multiselection,
            condition: con_item.condition,
            conditionValue: con_item.conditionValue,
            conditional: con_item.conditional,
            parent: con_item.parent,
            isopen: con_item.isopen,
            parent: con_item.id,
            type: con_item.type,
            is_subquestion: con_item.is_subquestion,
          };
        }),
        subQuestionList: item.subQuestionList.map((sub_item) => {
          return {
            id: "New-" + uuid(),
            title: sub_item.title,
            dataType: sub_item.dataType,
            position: sub_item.position,
            status: "New",
            responseLibrary: sub_item.responseLibrary,
            mandatory: sub_item.mandatory,
            multiselection: sub_item.multiselection,
            condition: sub_item.condition,
            conditionValue: sub_item.conditionValue,
            conditional: sub_item.conditional,
            parent: sub_item.parent,
            isopen: sub_item.isopen,
            parent: sub_item.id,
            type: sub_item.type,
            is_subquestion: sub_item.is_subquestion,
          };
        }),
      };
      newList.push(newItem);
    });

    var newSection = {
      id: newID,
      title: currentSection.title + "- Copy",
      type: "section",
      position: addingIndex,
      status: "New",
      checklist: {
        template: { id: newID },
        list: newList,
      },
    };

    //temp.splice(addingIndex, 0, section);
    //newSection.position=addingIndex
    // newSection.checklist.list.map(item=>{
    //   item.status="New"
    //   item.id= "New-" + uuid()
    // })
    temp.splice(addingIndex, 0, newSection);
    temp.map((item, index) => {
      if (item.status != "deleted" && item.status != "New") {
        item.status = "changed";
      }
      item.position = index + 1;
    });

    setActiveSection(addingIndex);
    setTemplate(temp);
  };

  const addNewSection = (templateId) => {
    //copyNewSection()
    //return
    console.log(templateId);
    var temp = [...template];
    // var indx = temp.findIndex((x) => x.id == templateId);
    var indx = activeSection;
    console.log(indx);
    if (indx != -1) {
      var newID = uuid();
      var section = {
        id: newID,
        title: "",
        type: "section",
        position: 1,
        status: "New",
        checklist: {
          template: { id: newID },
          list: [
            {
              id: "New-" + uuid(),
              title: "",
              dataType: "Text field",
              position: 1,
              status: "New",
              responseLibrary: [],
              mandatory: true,
              multiselection: false,
              condition: "",
              conditionValue: "",
              conditional: "no",
              parent: null,
              isopen: "no",
              conditionalList: [],
              subQuestionList: [],
              type: "question",
              is_subquestion: "no",
            },
          ],
        },
      };

      var addingIndex = 0;
      if (indx < temp.length) {
        addingIndex = indx + 1;
      }
      if (indx == temp.length) {
        addingIndex = indx;
      }
      temp.push(section);
      // temp.splice(addingIndex, 0, section);
      temp.map((item, index) => {
        if (item.status != "deleted" && item.status != "New") {
          item.status = "changed";
        }
        item.position = index + 1;
      });

      setActiveSection(addingIndex + 1);
      setTemplate(temp);
      return;
    }
  };
  const updateSection = (templateId, title, action) => {
    //alert('Deleting..')
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let user = data.user;
    let token = data.token;
    var temp = [...template];
    // var indx = temp.findIndex((x) => x.id == templateId);
    var indx = activeSection;
    console.log(indx, templateId);
    if (indx != -1) {
      if (action == "update") {
        temp[indx].title = title;
        console.log("title", temp[indx].title, title);
        if (temp[indx].status != "New") {
          temp[indx].status = "changed";
        }
        setTemplate([...temp]);
        return;
      }
      if (action == "delete") {
        //alert(indx)
        //temp.splice(indx,1)
        swal({
          title: t("Are you sure?"),
          // text: "You will not be able to recover this imaginary file!",
          icon: "warning",
          buttons: [t("No, cancel it!"), t("Yes, I am sure!")],
          dangerMode: true,
        }).then(async function(isConfirm) {
          // let indx = temp
          //   .findIndex((x) => x.position == temp[activeSection].position);
          console.log(indx, "INDEXs", temp[activeSection].id);
          if (isConfirm) {
            // temp.push(deletedSection);
            try {
              await fetch(GlobalApi + "/Section/edit_section", {
                method: "post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  section_id: temp[activeSection].id,
                  status: "frozen",
                  // updated_by: user,
                }),
              });
            } catch (err) {
              console.log("DELETED", err);
            }
            temp[indx].status = "deleted";
            // var deletedSection = temp[indx];
            temp.splice(indx, 1);
            setActiveSection(activeSection - 1);

            setTemplate(temp);

            return;
          }
        });
      }
    }
  };

  const deleteConditionalChecklist = async (token) => {
    console.log("deleteChecklistArr", deleteChecklistArr);

    let req = await fetch(
      GlobalApi + "/CheckList/delete_conditional_checklist",
      {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({ check_id: deleteChecklistArr }),
      }
    );
    let res = await req.json();
    console.log("response from delete checklist ", res.data);

    setDeleteChecklistArr([]);
  };

  const deleteSubQuestionChecklist = async (token) => {
    console.log("deleteChecklistArr", deleteChecklistArr);

    let req = await fetch(
      GlobalApi + "/CheckList/delete_conditional_checklist",
      {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({ check_id: deleteChecklistArr }),
      }
    );
    let res = await req.json();
    console.log("response from delete checklist ", res.data);

    setDeleteChecklistArr([]);
  };

  const handleDataType = (val) => {
    setDataType(val);
  };

  const addNewLogicalQuestion = (
    itemId,
    checklistId,
    sectionId,
    actionType
  ) => {
    // alert('Adding new question..'+itemId+' checklistId'+checklistId +' sectionId:'+sectionId)
    //return

    var temp = [...template];
    // var indx = temp.findIndex((x) => x.id == sectionId);
    let indx = activeSection;
    console.log(
      indx,
      temp[indx].checklist.list.findIndex((x) => x.id == checklistId)
    );

    if (indx != -1) {
      if (actionType == "new") {
        var checklistIndex = temp[indx].checklist.list.findIndex(
          (x) => x.id == checklistId
        );
        //var index= temp[indx].checklist.list.findIndex(x=>x.id==itemId)
        var list = temp[indx].checklist.list;

        var addingId = 0;
        var addingIndex = 0;

        if (
          checklistIndex <
          temp[indx].checklist.list[checklistIndex].conditionalList.length
        ) {
          addingId = "New-" + uuid();
          addingIndex = checklistIndex + 1;
        }
        if (
          checklistIndex ==
          temp[indx].checklist.list[checklistIndex].conditionalList.length
        ) {
          addingId = "New-" + checklistIndex;
          addingIndex = checklistIndex;
        }
        var newItem = {
          id: addingId,
          title:
            "Condition field " +
            temp[indx].checklist.list[checklistIndex].conditionalList.length +
            1,
          dataType: "Text field",
          position:
            temp[indx].checklist.list[checklistIndex].conditionalList.length +
            1,
          status: "New",
          responseLibrary: [],
          mandatory: true,
          multiselection: false,
          condition: "",
          conditionValue: "",
          conditional: "no",
          is_subquestion: "no",
          type: "conditional",

          parent: temp[indx].checklist.list[checklistIndex].id,
        };

        list[checklistIndex].conditionalList.splice(addingIndex, 0, newItem);
        if (temp[indx].status != "New") {
          temp[indx].status = "changed";
        }
        if (temp[indx].checklist.list[checklistIndex].status != "New") {
          temp[indx].checklist.list[checklistIndex].status = "changed";
        }
        temp[indx].checklist.list = list;
        setTemplate(temp);
      }
    }
  };

  const addSection = async (
    title,
    template_id,
    user,
    checklist,
    token,
    type,
    position
  ) => {
    var obj = {
      title: title,
      template_id: template_id,
      status: "active",
      created_by: user,
      type: type,
      position: position,
    };
    var token = token;
    fetch(GlobalApi + "/Section/create_section", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log(res.data);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          for (const item of checklist) {
            
            //alert(JSON.stringify(item.responseLibrary.responses))
            if (item.status == "New" || item.status == "changed") {
              await addChecklistItem(
                item.title,
                res.data.id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                item.parent,
                item.subQuestion,
                item.conditionalList,
                item.subQuestionList,
                item.type,
                item.is_subquestion
              );
            }
          }
          getTemplate(TEMPLATE_ID, "save");

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addNewSection(title, template_id, user, checklist, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  const addChecklistItem = async (
    title,
    section_id,
    user,
    position,
    dataType,
    token,
    responseLibrary,
    mandatory,
    multiselection,
    condition,
    conditionValue,
    conditional,
    parent,
    subQuestion,
    conditionalList,
    subQuestionList,
    type,
    is_subquestion
  ) => {

    
    var obj = {
      title: title,
      section_id: section_id,
      status: "active",
      created_by: user,
      position: position,
      data_type: dataType,
      is_mandatory: mandatory,
      is_multiple_allowed: multiselection,
      condition: condition,
      condition_value: conditionValue,
      is_conditional: conditional,
      parent_id: parent,
      is_subquestion: is_subquestion,
      type: type,
    };

    // console.log("obj", obj);
    // return;
    var token = token;
    let req = await fetch(GlobalApi + "/CheckList/create_check_list", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    });
    let res = await req.json();
    console.log("response from get Create checklist ", res.data);
    if (res.status === "Success") {
      //===================== Add checklist===============//
      if (dataType == "Custom" || dataType == "Global") {
        // await responseLibrary.responses.map((r, index) => {
        // this.addResponseLibrary(
        //   r.title,
        //   res.data.id,
        //   r.id,
        //   user,
        //   token,
        //   index == 0 ? true : false
        // );
        console.log("JSN");
        let req = await fetch(GlobalApi + "/ResponseSet/create_response_sets", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            check_id: res.data.id,
            responses: responseLibrary.responses,
          }),
        });

        let reqJson = await req.json();
        console.log(responseLibrary.responses, "JSN");
        console.log("response from create REsponse sets ", reqJson);
        // });
      }
      //==================================================//
      //===================== Add Conditional checklist===============//
      if (conditional == "yes") {
        await conditionalList.map(async (item) => {
          // if (item.status == "New")
          await addChecklistItem(
            item.title,
            section_id,
            user,
            item.position,
            item.dataType,
            token,
            item.responseLibrary,
            item.mandatory,
            item.multiselection,
            item.condition,
            item.conditionValue,
            item.conditional,
            res.data.id,
            item.subQuestion,
            item.conditionalList,
            item.subQuestionList,
            item.type,
            item.is_subquestion
          );

          if (item.status == "changed" || item.status == "deleted")
            await updateChecklistItem(
              item.title,
              section_id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.status,
              item.id,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.subQuestion,
              item.conditionalList,
              item.subQuestionList,
              item.type,
              item.is_subquestion
            );
        });
        setBtnLoader(false);
      }

      //===================== Add sub checklist===============//
      if (is_subquestion == "yes") {
        await subQuestionList.map(async (item) => {
          // if (item.status == "New")
          await addChecklistItem(
            item.title,
            section_id,
            user,
            item.position,
            item.dataType,
            token,
            item.responseLibrary,
            item.mandatory,
            item.multiselection,
            item.condition,
            item.conditionValue,
            item.conditional,
            res.data.id,
            item.subQuestion,
            item.conditionalList,
            item.subQuestionList,
            item.type,
            item.is_subquestion
          );

          if (item.status == "changed" || item.status == "deleted")
            await updateChecklistItem(
              item.title,
              section_id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.status,
              item.id,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.subQuestion,
              item.conditionalList,
              item.subQuestionList,
              item.type,
              item.is_subquestion
            );
        });
        setBtnLoader(false);
      }

      

      //==================================================//
    } else if (
      res.error === "jwt expired" ||
      res.error === "invalid token" ||
      res.error === "invalid signature" ||
      res.error == "Unexpected token"
    ) {
      let status = await refresh_token();
      console.log(status);
      if (status) {
        console.log("opopopop");
        await addChecklistItem(
          title,
          section_id,
          user,
          position,
          dataType,
          token,
          responseLibrary,
          mandatory,
          multiselection,
          condition,
          conditionValue,
          conditional,
          parent,
          subQuestion,
          conditionalList,
          subQuestionList,
          type,
          is_subquestion
        );
      }
    }
  };

  const updateTemplateSection = async (
    title,
    template_id,
    user,
    checklist,
    token,
    type,
    position,
    sectionId,
    status
  ) => {
    //alert('Title '+title+' position'+position)
    var obj = {
      title: title,
      section_id: sectionId,
      status: status == "deleted" ? "frozen" : "active",
      updated_by: user,
      type: type,
      position: position,
    };

    console.log(obj, "setio req");
    var token = token;
    fetch(GlobalApi + "/Section/edit_section", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    })
      .then((response) => response.json())
      .then(async (res) => {
        console.log("Section >1>>>>>>>>>>", checklist);
        if (res.status === "Success") {
          //===================== Add checklist===============//
          for (const item of checklist) {
           
            if (item.status == "New")
              await addChecklistItem(
                item.title,
                res.data.id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                item.parent,
                item.subQuestion,
                item.conditionalList,
                item.subQuestionList,
                item.type,
                item.is_subquestion
              );

            if (item.status == "changed" || item.status == "deleted"){
           
              await updateChecklistItem(
                item.title,
                res.data.id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.status,
                item.id,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                item.parent,
                item.subQuestion,
                item.conditionalList,
                item.subQuestionList,
                item.type,
              item.is_subquestion
              );
            }
            if (item.status == "conditionalDeleted"){
              await updateChecklistItem(
                item.title,
                res.data.id,
                user,
                item.position,
                item.dataType,
                token,
                item.responseLibrary,
                item.status,
                item.id,
                item.mandatory,
                item.multiselection,
                item.condition,
                item.conditionValue,
                item.conditional,
                item.parent,
                item.subQuestion,
                item.conditionalList,
                item.subQuestionList,
                item.type,
              item.is_subquestion
              );
                deleteConditionalChecklist(token);
            }
            

              if (item.status == "subDeleted"){
                await updateChecklistItem(
                  item.title,
                  res.data.id,
                  user,
                  item.position,
                  item.dataType,
                  token,
                  item.responseLibrary,
                  item.status,
                  item.id,
                  item.mandatory,
                  item.multiselection,
                  item.condition,
                  item.conditionValue,
                  item.conditional,
                  item.parent,
                  item.subQuestion,
                  item.conditionalList,
                  item.subQuestionList,
                  item.type,
                item.is_subquestion
                );
                deleteSubQuestionChecklist(token);
              }
          }
          getTemplate(TEMPLATE_ID, "saved");

          // getTemplate(TEMPLATE_ID);
          // setBtnLoader(false);

          //==================================================//
        } else if (
          res.error === "jwt expired" ||
          res.error === "invalid token" ||
          res.error === "invalid signature" ||
          res.error == "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            console.log("opopopop");
            addNewSection(title, template_id, user, checklist, token);
          }
        }
      })
      .catch((err) => {
        console.log(err, "error");
      });
  };
  const updateChecklistItem = async (
    title,
    section_id,
    user,
    position,
    dataType,
    token,
    responseLibrary,
    status,
    check_id,
    mandatory,
    multiselection,
    condition,
    conditionValue,
    conditional,
    parent,
    subQuestion,
    conditionalList,
    subQuestionList,
    type,
    is_subquestion
  ) => {
    
    //alert('Title '+title+' condition'+condition)
    var obj = {
      title: title,
      check_id: check_id,
      status: status == "deleted" ? "frozen" : "active",
      updated_by: user,
      position: position,
      data_type: dataType,
      is_mandatory: mandatory,
      is_multiple_allowed: multiselection,
      condition: condition,
      condition_value: conditionValue,
      is_conditional: conditional,
      parent_id: parent,
      type: type,
      subQuestion: subQuestion,
      is_subquestion: subQuestion,
    };
    var token = token;
    let req = await fetch(GlobalApi + "/CheckList/edit_check_list", {
      method: "post",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(obj),
    });
    let res = await req.json();
    console.log(res.data);
    if (res.status === "Success") {
      //===================== Add checklist===============//
      if (dataType == "Custom" || dataType == "Global") {
        // await responseLibrary.responses.map(async (r, index) => {

        //   await this.addResponseLibrary(
        //     r.title,
        //     res.data.id,
        //     r.id,
        //     user,
        //     token,
        //     index == 0 ? true : false
        //   );
        // });

        console.log("JSN");
        let req = await fetch(GlobalApi + "/ResponseSet/create_response_sets", {
          method: "post",
          headers: new Headers({
            Authorization: "Bearer " + token,
            "Content-Type": "application/json",
          }),
          body: JSON.stringify({
            check_id: res.data.id,
            responses: responseLibrary.responses,
          }),
        });

        let reqJson = await req.json();
        console.log(responseLibrary.responses, "JSN");
        console.log("response from create Response sets ", reqJson);

        // });
      }
      //==================================================//

      //===================== Add Conditional checklist===============//
      if (conditional == "yes" && conditionalList) {
        conditionalList.map(async (item) => {
          if (item.status == "New")
            await addChecklistItem(
              item.title,
              section_id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.subQuestion,
              item.conditionalList,
              item.subQuestionList,
              item.type,
              item.is_subquestion
            );

          if (item.status == "changed" || item.status == "deleted")
            await updateChecklistItem(
              item.title,
              section_id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.status,
              item.id,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.subQuestion,
              item.conditionalList,
              item.subQuestionList,
              item.type,
              item.is_subquestion
            );
        });
      }

      //==========================Add Sub Checklist========================//

      if (is_subquestion == "yes" && subQuestionList) {
        subQuestionList.map(async (item) => {
          if (item.status == "New")
            await addChecklistItem(
              item.title,
              section_id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.subQuestion,
              item.conditionalList,
              item.subQuestionList,
              item.type,
              item.is_subquestion
            );

          if (item.status == "changed" || item.status == "deleted")
            await updateChecklistItem(
              item.title,
              section_id,
              user,
              item.position,
              item.dataType,
              token,
              item.responseLibrary,
              item.status,
              item.id,
              item.mandatory,
              item.multiselection,
              item.condition,
              item.conditionValue,
              item.conditional,
              item.parent,
              item.subQuestion,
              item.conditionalList,
              item.subQuestionList,
              item.type,
              item.is_subquestion
            );
        });
      }


      //==================================================//
    } else if (
      res.error === "jwt expired" ||
      res.error === "invalid token" ||
      res.error === "invalid signature" ||
      res.error == "Unexpected token"
    ) {
      let status = await refresh_token();
      console.log(status);
      if (status) {
        console.log("opopopop");
        updateChecklistItem(
          title,
          section_id,
          user,
          position,
          dataType,
          token,
          responseLibrary,
          status,
          check_id,
          mandatory,
          multiselection,
          condition,
          conditionValue,
          conditional,
          parent,
          subQuestion,
          conditionalList,
          subQuestionList,
          type,
          is_subquestion
        );
      }
    }
  };

  function handleSectionIndex(index) {
    console.log("index", index);
    setActiveSection(index);
    setOpen(false);
  }

  async function handleSectionSave(index) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let user = data.user;
    let token = data.token;
    let section = template[index];
    console.log(
      ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",
      template[index]
    );
    if (section.status == "added") {
      setBtnLoader(false);
    }
    if (section.status == "New") {
      await addSection(
        section.title,
        TEMPLATE_ID,
        user,
        section.checklist.list,
        token,
        section.type,
        section.position
      );
    }

    if (section.status == "changed" || section.status == "deleted") {
     
      await updateTemplateSection(
        section.title,
        TEMPLATE_ID,
        user,
        section.checklist.list,
        token,
        section.type,
        section.position,
        section.id,
        section.status
      );
    }
    // console.log("power");
  }

  const onDragSection = async (
    checklist,
    template_1,
    source,
    destinationIndex,
    action
  ) => {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let user = data.user;
    let token = data.token;

    let currentIndex = activeSection;
    let currentSectionId = template[currentIndex]?.id;
    console.log(checklist);

    await onUpdateChecklist(
      checklist,
      template_1,
      source,
      destinationIndex,
      action
    );
    setActiveSection(checklist.findIndex((e) => e.id === currentSectionId));

    console.log(
      checklist.findIndex((e) => e.id === currentSectionId),
      currentIndex
    );
    let i = 1;
    for (var section of checklist) {
      let req = await fetch(GlobalApi + "/Section/edit_section", {
        method: "post",
        headers: new Headers({
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        }),
        body: JSON.stringify({
          section_id: section.id,
          position: i,
          updated_by: user,
        }),
      });
      i++;
      let reqJson = await req.json();
    }

    // getTemplate(TEMPLATE_ID)
  };

  function handleModal() {
    setOpen(!open);
  }

  if (template === null || templateDetails === null) {
    return (
      <div style={{ minHeight: "85vh" }}>
        <Spinner />
      </div>
    );
  } else {
    // console.log(template);
    return (
      <div
        className=""
        style={{
          flexGrow: 1,
          backgroundColor: Colors.globalColor9,
          minHeight: "80vh",
          padding: "10px",
          overflowY: "scroll",
        }}
      >
        <Grid container className="temp-cont">
          <Header
            title={templateDetails.title}
            description={templateDetails.description}
            template_id={templateDetails.id}
          />

          {window.innerWidth <= 960 && (
            <Grid container spacing={1}>
              {" "}
              <Grid item xs={8}>
                {" "}
                <FormControl size="small" variant="outlined" fullWidth>
                  <Select
                    size="small"
                    labelId="demo-simple-select-outlined-label"
                    id="demo-simple-select-outlined"
                    style={{ backgroundColor: "white" }}
                    value={activeSection}
                    onChange={(e) => handleSectionIndex(e.target.value)}
                    fullWidth
                  >
                    {template
                      .filter((v) => v !== undefined && v.status !== "deleted")
                      .map((item, index) => {
                        return (
                          <MenuItem value={index}>
                            <p
                              className="templateName"
                              style={{ margin: 0, fontSize: 14 }}
                            >
                              {item.title.slice(0, 25) +
                                (item.title.length > 25 ? "..." : "")}
                            </p>
                          </MenuItem>
                        );
                      })}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <Button
                  type="button"
                  onClick={handleModal}
                  className="addBtn"
                  component="span"
                  style={{ backgroundColor: "#043077", width: "100%" }}
                >
                  {"Preview"}
                </Button>
              </Grid>
            </Grid>
          )}

          <Grid item xs={12}>
            <Grid container spacing={1} direction="row">
              <Grid
                item
                xs={12}
                md={8}
                style={{ padding: "10px" }}
                className="scroll"
              >
                {/* <Container> */}
                <Sections
                  sections={template.filter(
                    (v) => v !== undefined && v.status !== "deleted"
                  )}
                  template_id={templateDetails.id}
                  activeSection={activeSection}
                  setType={handleDataType}
                  onUpdateChecklist={onUpdateChecklist}
                  addNewQuestion={addNewQuestion}
                  addNewCondition={addNewCondition}
                  addNewSubQuestion={addNewSubQuestion}
                  deleteCondition={deleteCondition}
                  deleteSubQuestion={deleteSubQuestion}
                  addNewSection={addNewSection}
                  updateSection={updateSection}
                  addNewLogicalQuestion={addNewLogicalQuestion}
                  responseLibrary={responseLibrary}
                  getResponseLibrary={getResponseLibrary}
                  handleSectionSave={handleSectionSave}
                  btnLoader={btnLoader}
                  setBtnLoader={setBtnLoader}
                  copyNewSection={copyNewSection}
                />
                {/* <DarkButton
                  startIcon={<AddIcon style={{color:'white'}}/>}
                  style={{ marginLeft: 5, backgroundColor:Colors.globalColor8, color:'white' }}
                  disabled={btnLoader === true}
                  onClick={() => {
                    if (btnLoader === false) {
                      console.log("loader", btnLoader);
                      setBtnLoader(true);
                      handleSectionSave(activeSection);
                    }
                  }}
                >
                  Save
                </DarkButton> */}

                <Button
                  variant="contained"
                  type="submit"
                  className="addBtn"
                  component="span"
                  startIcon={
                    btnLoader && (
                      <CircularProgress
                        size={18}
                        style={{ color: "white", marginRight: 7 }}
                      />
                    )
                  }
                  disabled={btnLoader === true}
                  style={{ backgroundColor: "#043077" }}
                  onClick={() => {
                    if (btnLoader === false) {
                      console.log("loader", btnLoader);
                      setBtnLoader(true);
                      handleSectionSave(activeSection);
                    }
                  }}
                >
                  {"Save"}
                </Button>

                <Button
                  variant="contained"
                  className="cancelBtn"
                  style={{ width: "80px" }}
                  onClick={() => history.goBack()}
                >
                  Cancel
                </Button>

                {/* </Container> */}
              </Grid>
              {window.innerWidth >= 960 ? (
                <Grid
                  item
                  sm={12}
                  md={4}
                  style={{ padding: 10 }}
                  className="scroll"
                >
                  <Preview
                    showdata={dataType}
                    template={template.filter(
                      (v) => v !== undefined && v.status !== "deleted"
                    )}
                    handleSectionIndex={handleSectionIndex}
                    onDragSection={onDragSection}
                    addNewSection={addNewSection}
                  />
                </Grid>
              ) : (
                <CustomizedDialogs
                  preview={
                    <Preview
                      showdata={dataType}
                      template={template.filter(
                        (v) => v !== undefined && v.status !== "deleted"
                      )}
                      handleSectionIndex={handleSectionIndex}
                      onDragSection={onDragSection}
                    />
                  }
                  handleClose={handleModal}
                  open={open}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

function CustomizedDialogs({ open, preview, handleClose }) {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullScreen={fullScreen}
      >
        <DialogTitle id="customized-dialog-title" onClose={handleClose}>
          Preview
        </DialogTitle>
        <DialogContent dividers>{preview}</DialogContent>
        <div align="left" style={{ textAlign: "left", padding: 10 }}>
          <DarkButton autoFocus onClick={handleClose} color="primary">
            Close
          </DarkButton>
        </div>
      </Dialog>
    </div>
  );
}
